// extracted by mini-css-extract-plugin
export default {"expand":"table-merchant_expand__+Gjq8","expanded":"table-merchant_expanded__-R80z"};